export interface ITwoFactorAuthenticationRequest {
    Token: string;
    Code: string;
    DeviceID: string;
    RememberDevice: boolean;
    IsGoogleCode: boolean;
}

export class TwoFactorAuthenticationRequest implements ITwoFactorAuthenticationRequest {
    Token: string;
    Code: string;
    DeviceID: string;
    RememberDevice: boolean;
    IsGoogleCode: boolean;
}
